export default {
  settings: {
    endpointsSectionTitle: 'Puncte finale ale serviciului (URI sau URL complet)',
    language: 'Limbă',
    appLocale: 'App local',
    unit: 'Unitate',
    saveToLocalStorage: 'Salvați în browserul meu',
    routeInstructions: 'Instrucțiuni de rutare',
    alternativeIsochroneColors: 'Culori izocrone alternative',
    elevationProfile: 'Profil de elevație',
    mapSettings: 'Vizualizarea hărții și informații suplimentare',
    endpointsTitle: {
      directions: 'Direcții',
      isochrones: 'Izocronii',
      geocodeSearch: 'Căutare prin geocodare',
      autocomplete: 'Completarea automată a geocodului',
      pois: 'POIs',
      reverseGeocode: 'Geocodare inversă',
    },
    apiKey: 'Cheia API',
    customApiKey: 'Cheie API personalizată',
    apiBaseUrl: 'URL de bază API',
    restoreDefaults: 'Restabilirea valorilor implicite',
    advanced: 'Avansat',
    mapSettingsSaved: 'Setări de hartă salvate',
    routeExtraInfo: 'Informații suplimentare despre rută',
    mapViewOptions: 'Opțiuni de vizualizare a hărții',
    advancedSettingsWarning: 'Nu modificați setările de mai jos dacă nu știți ce faceți!',
    customTileProviderUrl: 'URL-ul furnizorului de dale personalizate',
    defaultTilesProvider: 'Furnizorul de dale implicit',
    customTileProviderUrlHint: 'https://domain.tld/path/{z}/{x}/{y}.ext?optionalKey=value',
    prioritizeSearchingForNearbyPlaces: 'Prioritizează căutarea de locuri din apropiere',
    defaultProfile: 'Profil implicit',
    autoFitHighlightedBounds: 'Auto se potrivesc limitele evidențiate',
    resetShownOnceTooltips: 'Afișați din nou tooltips la încărcarea aplicației',
    convertStopAfterRouteEndingToDestination: 'Oprire de conversie adăugată la sfârșitul traseului către destinația finală',
    skipAllSegments: 'traseu drept pentru toate segmentele',
    useStopOptimization: 'Optimizarea traseului atunci când se creează o oprire prin glisare și fixare',
    areaUnit: 'Unitatea de suprafață',
    distanceMarkers: 'Indicatori de distanță',
    defaultMapSettingsRestored: 'Setări implicite ale hărții restaurate și salvate',
    invalidSettingsValue: 'Valoare(e) nevalabilă(e) a(le) setărilor. Vă rugăm să verificați câmpurile sau să restaurați valorile implicite',
    alwaysFitBounds: 'Întotdeauna se potrivesc limitele atunci când se schimbă traseul',
    customOverlayerTileProviderUrl: 'URL-ul furnizorului de suprapunere personalizat',
    compressDataUrlSegment: 'Comprimarea segmentului URL după /data/',
    reloadToApplyLanguageChangeTitle: 'Este necesar să reîncărcați aplicația',
    reloadToApplyLanguageChangeText: 'Pentru a aplica complet schimbarea de limbă, este necesar să reîncărcați aplicația. Reîncărcați acum?',
  }
}
